import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './context/AuthContext';
import { CompanyProvider } from './context/CompanyContext';
import './App.css';
import AdminRoutes from './routes/AdminRoutes';

// Crear cliente de React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1
    }
  }
});

function App() {
  useEffect(() => {
    // Verificar si hay token en la URL (integración externa)
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    const companyId = urlParams.get('companyId');

    if (token && companyId) {
      // Guardar token y companyId
      localStorage.setItem('numbers_token', token);
      localStorage.setItem('numbers_company_id', companyId);
      localStorage.setItem('numbers_selected_company_id', companyId);
      localStorage.setItem('auth_token', token); // Para compatibilidad

      // Limpiar URL
      const newUrl = window.location.pathname;
      window.history.replaceState({}, document.title, newUrl);
    }
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <CompanyProvider>
        <Router>
          <Routes>
            {/* Rutas del panel de administración */}
            <Route path="/*" element={<AdminRoutes />} />
          </Routes>
        </Router>
        </CompanyProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
